import * as React from 'react'
import { Channel } from 'stream-chat'
import {
  ChannelAvatar as StreamChatChannelAvatar,
  useChannelPreviewInfo,
  useChannelStateContext,
  useChatContext,
} from 'stream-chat-react'

type IComponentProps = {
  onShowChannelEditModal: (channel: Channel) => void
}

const ChannelAvatar = (props: IComponentProps) => {
  const { client } = useChatContext()
  const { channel } = useChannelStateContext()
  const { displayImage } = useChannelPreviewInfo({channel})
  return (
    <div>
      <StreamChatChannelAvatar
        className='str-chat__avatar--channel-header'
        name={channel.data?.name}
        image={displayImage}
        onClick={async () => {
          // Only allow admins, moderators, or channel owners to edit channels (also enforced on the server)
          if (
            !channel ||
            (client.user?.role !== 'admin' &&
              client.user?.role !== 'moderator' &&
              (channel.data?.created_by as any)?.id !==
                client.user?.id)
          ) {
            return
          }
          props.onShowChannelEditModal(channel)
        }}
      />
    </div>
  )
}

export default ChannelAvatar
